
import { defineComponent } from "vue";
import { store } from "@/store";
import { update as updateApi } from "@smace-technologies/project/src/project";
import { show as showApi } from "@smace-technologies/project/src/project";

export default defineComponent({
  components: {},
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },
  emits: ["reload"],
  data() {
    return {
      submitted: false,
      loading: false,
      name: "",
    };
  },
  computed: {},
  watch: {
    projectId: function () {
      this.load();
    },
  },
  mounted() {
    this.load();
    this.name = "";
  },
  methods: {
    load: async function () {
      this.loading = true;
      const res = await showApi(
        store.getters["getBaseWorkspaceId"],
        this.projectId,
        store.getters["getJWT"]
      );

      this.name = res.name;
      this.loading = false;
    },
    submit: async function () {
      this.submitted = true;
      await updateApi(
        store.getters["getBaseWorkspaceId"],
        this.projectId,
        {
          name: this.name,
        },
        store.getters["getJWT"]
      );
      this.submitted = false;
      const el = this.$refs["closeBtn"] as any;
      this.name = "";
      el.click();
      this.$emit("reload");
    },
  },
});
